/**
 * This component is a fork of react-phone-number.
 * `react-phone-number` uses a google library for formatting which has been removed from this fork.
 * This component uses a `formator` prop which does the formatting.
 *
 * 
 * Phone component used to get the user's phone number
 * - utilizes Google's libphonenumber for phone formatting (https://github.com/seegno/google-libphonenumber)
 * - used with account creation and can be a hidden input
 */

import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';
import TextInput from 'react-text-input';

const STYLES = {
	logoWrapper: {
		height: '100%',
		position: 'absolute',
		top: 0,
		right: 0
	},

	logo: {
		display: 'inline-block',
		verticalAlign: 'middle'
	},

	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
};

class PhoneNumber extends React.Component {
	static propTypes = {
		type: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		exampleNumber: PropTypes.string.isRequired,
		phoneCode: PropTypes.string,
		formator: PropTypes.func,
		country: PropTypes.string.isRequired,
		pattern: PropTypes.string,
		maxlength: PropTypes.number,
		required: PropTypes.bool,
		value: PropTypes.string,
		changePhone: PropTypes.func.isRequired,
		errorMessage: PropTypes.string,
		handleFocus: PropTypes.func,
		handleBlur: PropTypes.func,
	};

	static defaultProps = {
		type: 'tel',
		handleFocus: () => {},
		handleBlur: () => {}
	};

	state = {
		showIsRequiredError: false
	};

	/**
	* Get the formatted phone number using Google's libphonenumber
	* libphonenumber throws an error if the number provided is only 1 character long
	* @param {String} phone - the phone number
	* @return {String} phone - the formatted phone number
	*/
	getFormattedPhoneNumber = (phone = '') => {
		let { phoneCode } = this.props;

		let phoneNumber = phone;

		if (this.props.formator) {
			phoneNumber = this.props.formator(phoneCode, phoneNumber);
		}

		return phoneNumber;

	};

	/**
	* Check for a phoneNumber value
	* If the field is required, we should show that this field needs a value
	* @param {String} phoneNumber - the card number
	*/
	handleCheckForValue = (phoneNumber) => {
		const isRequired = this.props.required;
		this.setState({ showIsRequiredError: isRequired && !phoneNumber });
	};

	/**
	* Handle changing the phone number
	* Remove non-digits from the phone and pass it to Griffin to format it
	* @param {String} phone - the phone number
	* @return {String} phone - the formatted phone number
	*/
	handleChangePhone = (phone) => {
		phone = phone.replace(/\D/g, ''); // remove non-digits for when the griffin formatting kicks in
		this.handleCheckForValue(phone);
		this.props.changePhone(phone);
		return this.getFormattedPhoneNumber(phone);
	};

	/**
	* Call parent's handleFocus
	* @param {String} phoneNumber - the card number
	*/
	handleFocus = (phoneNumber) => {
		this.props.handleFocus(phoneNumber);
	};

	/**
	* Check for a security code value and call parent's handleBlur
	* @param {String} phoneNumber - the card number
	*/
	handleBlur = (phoneNumber) => {
		phoneNumber = phoneNumber.replace(/\D/g, '');
		this.handleCheckForValue(phoneNumber);
		this.props.handleBlur(phoneNumber, this.props.phoneCode);
	};

	render() {
		let phoneClassNames = classNames({
			hidden: this.props.type === 'hidden',
			'vx_form-control': this.props.type !== 'hidden',
			'vx_form-control_complex': this.props.type !== 'hidden'
		});
		let initialValue = this.getFormattedPhoneNumber(this.props.value);
		let { errorMessage } = this.props;
		let errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage) {
			errorStyles = { height: '100%' };
		}

		return (
			<div className={classNames({
				'vx_has-error-with-message': errorMessage,
				'vx_has-error': !errorMessage && this.state.showIsRequiredError
			})} style={{ margin: '0 0 10px', position: 'relative' }}>
				<TextInput
					type={this.props.type}
					name="phone"
					id="phone"
					className={phoneClassNames}
					label={this.props.label}
					helpText={this.props.exampleNumber}
					pattern={this.props.pattern}
					required={this.props.required}
					value={initialValue}
					handleBlur={this.handleBlur}
					handleFocus={this.handleFocus}
					handleChange={this.handleChangePhone} />

				{/* show the error message if it exists */}
				<div className={classNames({
					'vx_form-control-message': errorMessage
				})} style={{ ...STYLES.errorMessage, errorStyles }}>{errorMessage}</div>
			</div>
		);
	}
}

export default PhoneNumber;


// WEBPACK FOOTER //
// ./components/PhoneNumber.js